import * as yup from 'yup'
import { t } from 'translations'

// Messages are functions so they are translated when validation runs, not when this module loads.

export const reservationPoolValidationSchema = yup.object().shape({
    name: yup.string().trim().required(() => t('venue.bookingCodes.reservationCodePools.form.nameRequired')).max(100),
    externalChannel: yup.string().required(() => t('venue.bookingCodes.reservationCodePools.form.retailerRequired')),
})
